export default __webpack_public_path__ + "static/media/plain-sticker-pa.c5d917b3.png";